import { createSelector } from 'redux-orm';
import orm from 'models/orm';

export default createSelector(orm.Ticket);
